import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const accountApi = createApi({
  reducerPath: "accountApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    exportUserData: builder.query({
      query: () => "/account/export",
    }),
    deleteAccount: builder.mutation({
      query: (data) => ({ url: "/account", method: "DELETE", body: data }),
    }),
  }),
});

export const { useLazyExportUserDataQuery, useDeleteAccountMutation } = accountApi;
